import React from 'react'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import Box from '@mui/material/Box'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'

import { fieldErrorMessages } from 'lib/helpers/forms'

const PasswordFieldWithRequirements = props => {
  const {
    label,
    form,
    field,
    onChange,
    errors,
    inputErrors,
    required,
    showRequirements = true,
    requirements, // via withPasswordValidation
    allRequirementsMet // via withPasswordValidation
  } = props

  const password = form[field] || ''
  const errorMessages = fieldErrorMessages({ errors, inputErrors, field })

  return (
    <FormControl
      fullWidth
      margin='normal'
      error={errorMessages.length > 0}
      required={required}
    >
      <FormLabel htmlFor={field}>{label}</FormLabel>
      <TextField
        id={field}
        value={password}
        onChange={onChange(field)}
        type='password'
        variant='standard'
      />
      {errorMessages.map(message => (
        <FormHelperText key={message}>{message}</FormHelperText>
      ))}

      {showRequirements && (
        <Box sx={{ mt: 1 }}>
          <FormHelperText sx={{ mb: 0.5 }}>
            Your password must meet the following requirements:
          </FormHelperText>
          {Object.entries(requirements).map(([key, req]) => (
            <Box
              key={key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                color: req.met ? 'success.main' : 'text.secondary',
                fontSize: '0.75rem',
                lineHeight: 1.5
              }}
            >
              {req.met ? (
                <CheckCircleIcon sx={{ fontSize: '1rem' }} />
              ) : (
                <RadioButtonUncheckedIcon sx={{ fontSize: '1rem' }} />
              )}
              <span>{req.label}</span>
            </Box>
          ))}
        </Box>
      )}
    </FormControl>
  )
}

export default PasswordFieldWithRequirements
